import React from 'react';
import ReactDOM from 'react-dom';
import { Provider as ReduxProvider } from 'react-redux'
import './index.css';
import App from './App';
import configureStore from './redux/configureStore';
// import registerServiceWorker from './registerServiceWorker';

// eslint-disable-next-line import/prefer-default-export
export const store = configureStore();

ReactDOM.render(
  <ReduxProvider store={store}>
    <App />
  </ReduxProvider>,
  document.getElementById('root')
);
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js